const jQ = jQuery.noConflict();

const content = jQ('.team-member__excerpt-content');
const dots = '<i class="excerpt-dots">...</i>';
const more = '<a href="#" class="team-member__read-more">Read More</a>';
const max = 140;

function excerpt() {
    jQ('.hide-content').removeClass('hide-content');
    jQ('.team-member__read-more').remove();
    content.each(function () {
        if (jQ(this).html().length > max) {
            const text = jQ(this).contents().context.innerHTML;
            let short = text.substr(0, max);
            const checkOpen = short.match(/<p>/g).length;
            const checkClosed = short.match(/<\/p>/g);

            if ((checkClosed == null) || (checkClosed.length !== checkOpen)) {
                short = `${short}${dots}</p>`;
                jQ(this).html(`${short}`);
                jQ(this).parent().append(`${more}`);
            } else {
                jQ(this).html(`${short}${dots}`);
                jQ(this).parent().append(`${more}`);
            }

            let height = jQ(this).outerHeight();
            const buttonHeight = jQ('.team-member__read-more').outerHeight();
            let newHeight = height + buttonHeight;

            jQ(this).parent().find('.team-member__read-more').click(function (e) {
                jQ(this).toggleClass('less');
                e.preventDefault();
                if (jQ(this).hasClass('less')) {
                    jQ(this).html('Read Less');
                    jQ(this).parent().find('.team-member__hidden-content').addClass('visible');
                    jQ(this).parent().find('.team-member__excerpt-content').addClass('hide');
                    const hiddenHeight = jQ(this).parent().find('.team-member__hidden-content').outerHeight();

                    jQ(this).parent().animate({
                        height: hiddenHeight,
                    }, 200);

                    jQ(this).closest('.team-member__item').removeClass('align-items-lg-center');
                } else {
                    jQ(this).html('Read More');
                    jQ(this).parent().find('.team-member__hidden-content').removeClass('visible');
                    jQ(this).parent().find('.team-member__excerpt-content').removeClass('hide');
                    height = jQ(this).parent().find('.team-member__excerpt-content').outerHeight();
                    newHeight = height + buttonHeight;

                    jQ(this).parent().animate({
                        height: newHeight,
                    }, 200);

                    jQ(this).closest('.team-member__item').delay(100).queue(function () {
                        jQ(this).addClass('align-items-lg-center').dequeue();
                    });
                }
            });
        }
    });
}

function changeHeight() {
    setTimeout(() => {
        jQ('.team-member__hidden-content.visible').each((index, element) => {
            const elHeight = jQ(element).outerHeight();
            jQ(element).parent().css({
                height: elHeight,
            });
        });
    }, 300);
}

export { excerpt, changeHeight };
